import React from 'react';
import type { CfbVisionIntakeBatch } from '../cfbScheduleVisionTypes';
import {
  intakeBatchPollFailed,
  pipelineProgressPercent,
  pipelineStageLabel,
} from '../cfbScheduleIntakePolling';

interface CfbScheduleIntakePipelineCardProps {
  batch: CfbVisionIntakeBatch;
  polling: boolean;
  pollError?: string | null;
}

const CfbScheduleIntakePipelineCard: React.FC<CfbScheduleIntakePipelineCardProps> = ({
  batch,
  polling,
  pollError,
}) => {
  const progress = pipelineProgressPercent(batch);
  const failed = intakeBatchPollFailed(batch);
  const stageLabel = pipelineStageLabel(batch.pipeline_stage);

  return (
    <section className="card p-6 space-y-4" data-testid="cfb-intake-pipeline-card">
      <div className="space-y-1">
        <h2 className="text-lg font-semibold text-white">Twitch VOD extraction</h2>
        <p className="text-secondary-300 text-sm" data-testid="cfb-intake-pipeline-stage">
          {batch.pipeline_message || stageLabel}
        </p>
        {batch.twitch_vod_id ? (
          <p className="text-secondary-500 text-xs">VOD ID: {batch.twitch_vod_id}</p>
        ) : null}
      </div>

      <div className="space-y-2">
        <div className="h-2 rounded-full bg-secondary-800 overflow-hidden">
          <div
            className={`h-full transition-all duration-500 ${
              failed ? 'bg-red-500' : 'bg-primary-500'
            }`}
            style={{ width: `${progress}%` }}
            data-testid="cfb-intake-pipeline-progress-bar"
          />
        </div>
        <div className="flex justify-between text-xs text-secondary-400">
          <span data-testid="cfb-intake-pipeline-stage-label">{stageLabel}</span>
          <span data-testid="cfb-intake-pipeline-progress-value">{progress}%</span>
        </div>
      </div>

      {polling ? (
        <p className="text-secondary-400 text-sm" data-testid="cfb-intake-pipeline-polling">
          Checking extraction status…
        </p>
      ) : null}

      {pollError ? (
        <p className="text-red-300 text-sm" data-testid="cfb-intake-pipeline-poll-error">
          {pollError}
        </p>
      ) : null}

      {batch.error_message ? (
        <p className="text-red-300 text-sm" data-testid="cfb-intake-pipeline-error">
          {batch.error_message}
        </p>
      ) : null}

      {batch.has_source_evidence ? (
        <p className="text-secondary-500 text-xs">Source VOD evidence stored for commissioner review.</p>
      ) : null}
    </section>
  );
};

export default CfbScheduleIntakePipelineCard;
